/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { Collapse } from 'reactstrap';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import NavbarMenuLink from './NavbarMenuLink.view';
import styles from './Navbar.styles';
import { handleChangeShop } from './Navbar.services';
import * as actions from '../../actions/index';
import { checkAccess } from '../../utils/admins';
import { signOut } from '../../apis/firebase';
import { ALLSHOP } from '../../constants';

function NavbarProfile({ shopName, logoUrl, shops, shopId, companyId, isAllShops, nbShops, setLoggedInUser, initPage }) {
  const [collapse, setCollapse] = useState(false);
  const [sortedShops, setSortedShops] = useState({});

  const toggle = () => (setCollapse(!collapse))


  useEffect(() => {
    setSortedShops(_.keys(shops)
      .sort((a, b) => shops[a].name.localeCompare(shops[b].name))
      .reduce((obj, cur) => ({ ...obj, [cur]: shops[cur] }), {}))
  }, [shops]);




  return (
    <div className='topbar__profile'>
      <button
        type='button'
        className='topbar__avatar'
        onClick={toggle}
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        {logoUrl && <img alt={shopName} className='img topbar__avatar-img mr-3' src={logoUrl} />}
        <p className='topbar__avatar-name' style={{ margin: 'auto' }}>
          {isAllShops ? ALLSHOP : shopName}
        </p>
        <KeyboardArrowDownIcon className='topbar__icon' style={styles.iconStyle} />
      </button>
      {collapse && <button type='button' className='topbar__back' onClick={toggle} />}
      <Collapse isOpen={collapse} className='topbar__menu-wrap' style={{ minWidth: '300px' }}>
        <div className='topbar__menu'>
          {checkAccess('features', 'changeShop') && (
            <div className='topbar__menu_list'>
              {!isAllShops && nbShops > 1 && (
                <NavbarMenuLink
                  title={ALLSHOP[0].toUpperCase() + ALLSHOP.slice(1)}
                  icon='store'
                  click={() => {
                    handleChangeShop(companyId, true, setLoggedInUser, initPage);
                    toggle()
                  }}
                  isAllShops
                />
              )}
              {_.map(sortedShops, (shop, key) => {
                const { name = '', closed, configuration = {} } = shop;
                const { completed = {} } = configuration
                const { firebase, stripe } = completed
                if (key !== shopId || isAllShops) {
                  return (
                    <NavbarMenuLink
                      title={name[0].toUpperCase() + name.slice(1)}
                      icon='store'
                      click={() => {
                        handleChangeShop(key, false, setLoggedInUser, initPage);
                        toggle()
                      }}
                      closed={closed}
                      completed={firebase && stripe}
                      key={key}
                    />
                  );
                }
              })}
            </div>
          )}
          <div className='topbar__menu-divider' />

          <NavbarMenuLink
            title='Déconnexion'
            icon='exit'
            click={() => {
              signOut();
            }}
          />
        </div>
      </Collapse>
    </div>
  );
}

function mapStateToProps({ user, firebaseRealTime }) {
  const { shopName, shopId, companyId, isAllShops, nbShops } = user;
  const { generalConfig, shops } = firebaseRealTime;
  const { logoUrl } = generalConfig;
  return {
    shopName,
    logoUrl,
    companyId,
    shops,
    shopId,
    isAllShops,
    nbShops
  };
}

export default connect(mapStateToProps, actions)(withRouter(NavbarProfile));
